module.exports = __webpack_public_path__ + "assets/google-analytics.edaafdb0.svg";